import classes from './tabs.module.css'

const Tabs = {
  defaultProps: {},
  classNames: {
    root: classes.root,
  },
}

export default Tabs
